import { render, staticRenderFns } from "./ExtratoCarteira.vue?vue&type=template&id=450ec323&scoped=true"
import script from "./ExtratoCarteira.vue?vue&type=script&lang=js"
export * from "./ExtratoCarteira.vue?vue&type=script&lang=js"
import style0 from "../cashback.css?vue&type=style&index=0&id=450ec323&prod&scoped=true&lang=css&external"
import style1 from "./ExtratoCarteira.vue?vue&type=style&index=1&id=450ec323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ec323",
  null
  
)

export default component.exports